<template>

  <div class="articlemanagement">

    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col :xs="24" :sm="24" :md="6" :lg="6">
            <Divider orientation="left">{{langMap.operationLog[lang]}}</Divider>
          </Col>
          <Col :xs="24" :sm="24" :md="18" :lg="18">
            <Form :label-width="100">
              <div class="des-cardTittle-box">
                <FormItem :label="langMap.logLevel[lang]" class="leftFlex">
                  <Select v-model="level" clearable>
                    <Option :key="item.id" :value="item.id" v-for="item in levelList">{{item.name}}</Option>
                  </Select>
                </FormItem>
                <FormItem :label="langMap.logDescription[lang]" class="leftFlex">
                  <Input v-model.trim="message " :placeholder="langMap.logDescription[lang]" clearable/>
                </FormItem>
                <FormItem :label="langMap.operator[lang]" class="leftFlex">
                  <Input v-model.trim="operatorName" :placeholder="langMap.operator[lang]" clearable/>
                </FormItem>
                <FormItem :label="langMap.operatorRole[lang]" class="leftFlex">
                  <Input v-model.trim="roleName" :placeholder="langMap.operatorRole[lang]" clearable/>
                </FormItem>
                <Button type="info" style="margin-left:20px;" @click="searchData">{{langMap.search[lang]}}</Button>
                <Button type="error" style="margin-left:20px;" @click="downData">{{langMap.download[lang]}}</Button>
              </div>
            </Form>
          </Col>
        </Row>
      </div>
      <Table :height="height" :loading="tableLoading" border :columns="col" :data="list"></Table>
      <!--分页数据-->
      <div style="text-align:center;padding-top:10px;" v-if="list.length>0">
        <Page :current="index" :total="total" :page-size="15" @on-change="goPageData"></Page>
      </div>
    </Card>

  </div>
</template>

<script>
  import api from "../../../api/index.js";
  import langMap from '@/utils/language';
  import { mapState } from 'vuex';
  export default {
    components: {
    },
    data() {
      return {
        langMap:langMap,
        height: (document.documentElement.clientHeight - 300),
        levelList:[],
        btnLoading: false,
        saveModal: false,
        
        list: [],
        index: 1,
        total: 0,
        //表格
        tableLoading: false,
        operatorName: '',
        message:'',
        roleName: '',
        level: ''
      }
    },
    computed: {
      ...mapState({
        lang: state => state.app.language,
      }),
      col() {
        return [
          {
            title: '#',
            width: 60,
            key: 'index',
            render(h, params) {
              return h("span", params.index + 1)
            }
          },
          {
            width: 210,
            title: langMap.groupId[this.lang],
            key: 'groupId'
          },
          {
            width: 200,
            title: langMap.logDescription[this.lang],
            key: 'message'
          },
          {
            title: langMap.level[this.lang],
            width: 90,
            key: 'level',
            render(h, params) {
              var text = "";
              var color = '';
              text = params.row.levelStr;
              if (params.row.level === 1) {
                color = '#ff9900';
              } else if (params.row.level === 2) {
                color = 'red';
              }
              return h("span", {
                style: {
                  color: color
                },
              }, text)
            }
          },
          {
            title: langMap.parameters[this.lang],
            key: 'params',
            width: 310,
            render: (h, params) => {
              return this.hideText(h, params.row.params, '300px')
            }
          },
          {
            width: 100,
            title: langMap.duration[this.lang],
            key: 'times',
          },
          {
            title: langMap.result[this.lang],
            key: 'result',
            width: 310,
            render: (h, params) => {
              return this.hideText(h, params.row.result, '300px')
            }
          },
          {
            width: 100,
            title: langMap.operator[this.lang],
            key: 'operatorName',
          },
          {
            width: 100,
            title: langMap.operatorRoleName[this.lang],
            key: 'operatorRoleName',
          },
          {
            title: langMap.createTime[this.lang],
            key: 'createTime',
            render(h, params) {
              var text = "";
              if (params.row.createTime) {
                text = params.row.createTime;
              } else {
                text = "-";
              }
              return h("span", text)
            }
          }
        ]
      }
    },
    methods: {
      downData(){
        api.download('log-server/export/operation/log?operatorName=' + this.operatorName
          + "&message=" + this.message + "&roleName=" + this.roleName+ "&level=" + (this.level || ''), '操作日志');
      },
      hideText(h,text, width){
        return h('div', [
          // 显示的位置上方
          h('Tooltip', {
            props: { placement: 'top' ,transfer: true}
          }, [
            h('span', {
              style: {
                display: 'inline-block',
                width: width,
                overflow: 'hidden',
                // 同样在这里隐藏溢出内容
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },
            }, text),
            // 显示的内容
            h('span', {
              slot: 'content',
              style: { whiteSpace: 'normal', wordBreak: 'break-all'}
            },text)
          ])
        ])
      },
      //获取列表
      getList() {
        this.tableLoading = true;
        api.getData('log-server/log/list?index=' + this.index + "&operatorName=" + this.operatorName
          + "&message=" + this.message + "&type=2&roleName=" + this.roleName + "&level=" + (this.level || ''), this).then((res) => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg,
            });
          } else {
            this.list = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        })
      },
      //搜索数据
      searchData() {
        this.index = 1;
        this.getList();
      },
      //分页数据
      goPageData(index) {
        this.index = index;
        this.getList();
      },
      getDic(){
        this.tableLoading = true;
        api.getData('log-server/log/dic', this).then((res) => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg,
            });
          } else {
            this.levelList = res.data;
          }
          this.tableLoading = false;
        })
      }
    },
    created() {
      this.getDic();
      this.getList();
    }
  }
</script>

<style>
</style>
